import MyHeartRateModal from "./index";

export default function MyHeartRateModalExamples() {
  return <MyHeartRateModal />;
}
